export default "__VITE_ASSET__DiWA8Ruk__"